import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "../styles/Userreceipt.css";

export const UserReceipt = ({ onBack }) => {
  const location = useLocation();
  const data = location.state;
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });

  if (!data) {
    return <div className="userreceipt-container">No receipt data found.</div>;
  }

  const {
    id,
    selectedDay,
    selectedNumbers = [],
    againstNumbers = [],
    price,
    minimumWin,
    maximumWin,
    limit = [],
  } = data;

  const showToast = (message, type = "info") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: "", type: "info" }), 2500);
  };

  const copyToClipboard = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(id);
        showToast("Booking code copied.", "success");
        return;
      }

      // Fallback for some mobile/older browsers
      const textArea = document.createElement("textarea");
      textArea.value = id;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        showToast("Booking code copied.", "success");
      } else {
        showToast("Unable to copy. Please copy the code manually.", "error");
      }
    } catch (err) {
      console.error("Failed to copy text: ", err);
      showToast("Unable to copy. Please copy the code manually.", "error");
    }
  };

  const formatAmount = (amount) => {
    const value = parseFloat(amount || 0);
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const showMaximumWin = !(
    (limit.includes(1) && limit.includes(2)) ||
    (limit.includes(1) && limit.includes(3)) ||
    (limit.includes(5) && limit.includes(13)) ||
    (limit.includes(6) && limit.includes(12))
  );

  return (
    <div className="userreceipt-container"> 
             <button
            className="userreceipt-back-btn"
            onClick={() => {
              if (onBack) onBack();
              else window.history.back();
            }}
            aria-label="Go back"
          >
            <ArrowLeft size={16} />
            <span>Return</span>
          </button>

      <div className="userreceipt-card">
        <div className="userreceipt-header-row">

          <div className="userreceipt-title-group">
            <h1 className="userreceipt-header">Bet Receipt</h1>
            <span className="userreceipt-subtitle">
              Share your booking code to love ones.
            </span>
          </div>

       
        </div>

        <div className="userreceipt-meta-row">
          <span className="userreceipt-tag">{selectedDay}</span>
          <div className="userreceipt-id">
            <span>Booking Code: {id}</span>
            <button onClick={copyToClipboard} className="userreceipt-copy-btn">
              Copy
            </button>
          </div>
        </div>

        <div className="userreceipt-section">
          <div className="userreceipt-section-header">
            <span className="userreceipt-label">Selected Numbers</span>
          </div>
          <div className="userreceipt-numbers">
            {selectedNumbers.map((num) => (
              <div key={`sel-${num}`} className="userreceipt-ball">
                {num}
              </div>
            ))}
          </div>
        </div>

        {againstNumbers.length > 0 && (
          <div className="userreceipt-section">
            <div className="userreceipt-section-header">
              <span className="userreceipt-label">Against Numbers</span>
            </div>
            <div className="userreceipt-against">
              {againstNumbers.map((num) => (
                <div
                  key={`agn-${num}`}
                  className="userreceipt-ball userreceipt-ball-alt"
                >
                  {num}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="userreceipt-section">
          <div className="userreceipt-section-header">
            <span className="userreceipt-label">Summary</span>
          </div>
          <div className="userreceipt-summary-grid">
            <div className="userreceipt-summary-item">
              <span className="userreceipt-summary-label">Stake</span>
              <span className="userreceipt-summary-value">
                GH₵ {formatAmount(price)}
              </span>
            </div>
            <div className="userreceipt-summary-item">
              <span className="userreceipt-summary-label">Minimum Win</span>
              <span className="userreceipt-summary-value">
                GH₵ {formatAmount(minimumWin)}
              </span>
            </div>
            {showMaximumWin && (
              <div className="userreceipt-summary-item">
                <span className="userreceipt-summary-label">Maximum Win</span>
                <span className="userreceipt-summary-value">
                  GH₵ {formatAmount(maximumWin)}
                </span>
              </div>
            )}
          </div>
        </div>

        <p className="userreceipt-footer-note">
          This receipt is your proof of entry. Winnings, if any, will be paid
          to your registered account according to Huntex Lotto terms.
        </p>
      </div>
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          {toast.message}
        </div>
      )}
    </div>
  );
};
